const asyncAllArray = async (array, callback) => {
  await Promise.all(
    array.map(async (element, index) => await callback(element, index, array))
  )
}

export default asyncAllArray